import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzXmas65 } from './pages'

type TIdToPageMapWoofzXmas65 = Record<PageIdWoofzXmas65, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_XMAS_65: TIdToPageMapWoofzXmas65 = {
  [PageId.SUBSCRIPTIONS_XMAS_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_65/pages/subscriptions/SubscriptionWoofzXmas65'
      ).then((m) => ({
        default: m.SubscriptionsXmas65,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_65/pages/subscriptions/SubscriptionWoofzXmas65'
      ),
  },
  [PageId.CHAT_UPSELL_XMAS_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_65/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_65/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_XMAS_65]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_xmas/woofz_xmas_65/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_xmas/woofz_xmas_65/pages/upsell/Upsell'),
  },
  [PageIdWoofzXmas65.DOWNLOAD_XMAS_65]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_65/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_xmas/woofz_xmas_65/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzXmas65.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
